import CheckIcon from "@mui/icons-material/Check";
import { Button, Select, MenuItem } from "@mui/material";
import { Spin } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { PsLabel } from "../../components";
import PsContext from "../../context";
import { useDialog } from "../../context/DialogContext";
import PsModalWindow from "../../components/PsModalWindow";
import { _ListState, _SAVE_AGENCIES } from "../../models/agenciesModel";
import { formToObject } from "../../utils";

const AddAgencyFormComponent = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [stateList, setStateList] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const { openDialog } = useDialog();

  useEffect(() => {
    loadStates();
  }, []);

  const loadStates = () => {
    setLoader(true);
    _ListState().then((res) => {
      if (res.status === "1") {
        setStateList(res.data);
      }
      setLoader(false);
    });
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    const mobileNo = form.mobile_no.value;
    const whatsappNo = form.whatsapp_no.value;
    console.log(selectedState);
    // Validate mobile numbers length
    if (mobileNo.length <= 5 || whatsappNo.length <= 5) {
      openDialog({
        title: "Validation Error",
        message: "Please Enter 10 Digit Mobile number.",
      });
      setValidated(true); // Trigger validation feedback
      return;
    }

    if (!selectedState) {
      openDialog({
        title: "Validation Error",
        message: "Select State.",
      });
      setValidated(true); // Trigger validation feedback
      return;
    }

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    setLoader(true);
    _SAVE_AGENCIES(formToObject(form)).then((res) => {
      if (res.status === "1") {
        form.reset();
        context.setAlertMsg(res.message || "Saved");
        if (props.onSuccess) props.onSuccess();
      } else {
        openDialog({
          title: "Error",
          message: res.message || "Error on Save",
        });
      }
      setLoader(false);
    });
  };

  return (
    <>
      <Spin spinning={loader}>
        <Form
          method="post"
          noValidate
          validated={validated}
          onSubmit={handleFormSubmit}
        >
          <input type="hidden" name="state" value={selectedState} />
          {/* Company Name */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Company Name" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="company_name"
                placeholder="Enter Company Name"
                size="sm"
                required
              />
            </Col>
          </Row>

          {/* Contact Person */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Contact Person" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="contact_person"
                placeholder="Enter Contact Person Name"
                size="sm"
                required
              />
            </Col>
          </Row>

          {/* Mobile No */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Mobile No" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="mobile_no"
                placeholder="+91 Enter Mobile No"
                size="sm"
                defaultValue="+91 "
                required
              />
            </Col>
          </Row>

          {/* Alternate Mobile No */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Alternate Mobile No" />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="alternate_mobile_no"
                placeholder="+91 Enter Alternate Mobile No"
                size="sm"
                defaultValue="+91 "
              />
            </Col>
          </Row>

          {/* WhatsApp No */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="WhatsApp No" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="whatsapp_no"
                placeholder="+91 Enter WhatsApp No"
                size="sm"
                defaultValue="+91 "
                required
              />
            </Col>
          </Row>

          {/* Telephone No */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Telephone No" />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="tel_no"
                placeholder="+91 Enter Telephone No"
                size="sm"
                defaultValue="+91 "
              />
            </Col>
          </Row>

          {/* Email */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Email" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter Email Address"
                size="sm"
                required
              />
            </Col>
          </Row>

          {/* Website */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Website" />
            </Col>
            <Col md={9}>
              <Form.Control
                type="url"
                name="website"
                placeholder="Enter Website URL"
                size="sm"
              />
            </Col>
          </Row>

          {/* Address 1 */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Address 1" required />
            </Col>
            <Col md={9}>
              <Form.Control
                as="textarea"
                name="address1"
                placeholder="Enter Address 1"
                size="sm"
                required
              />
            </Col>
          </Row>

          {/* Address 2 */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Address 2" />
            </Col>
            <Col md={9}>
              <Form.Control
                as="textarea"
                name="address2"
                placeholder="Enter Address 2"
                size="sm"
              />
            </Col>
          </Row>

          {/* Address 3 */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Address 3" />
            </Col>
            <Col md={9}>
              <Form.Control
                as="textarea"
                name="address3"
                placeholder="Enter Address 3"
                size="sm"
              />
            </Col>
          </Row>

          {/* City */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="City" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="city"
                placeholder="Enter City"
                size="sm"
                required
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Zip/Pin" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="pin_code"
                placeholder="Enter Pin code"
                size="sm"
                required
              />
            </Col>
          </Row>

          {/* State */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="State" />
            </Col>
            <Col md={9}>
              {stateList && stateList.length > 0 && (
                <Select
                  fullWidth
                  size="small"
                  value={selectedState}
                  onChange={(e) => setSelectedState(e.target.value)}
                  displayEmpty
                >
                  <MenuItem value="" disabled>
                    Select State
                  </MenuItem>
                  {stateList.map((state) => (
                    <MenuItem key={state.id} value={state.id}>
                      {state.state_name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </Col>
          </Row>

          {/* Country */}
          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Country" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="country"
                placeholder="Enter Country"
                size="sm"
                defaultValue="India"
                required
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="GST ID" required />
            </Col>
            <Col md={9}>
              <Form.Control
                type="text"
                name="gst_id"
                placeholder="Enter GST"
                size="sm"
                required
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Notes" />
            </Col>
            <Col md={9}>
              <Form.Control
                as="textarea"
                name="notes"
                placeholder="Enter Notes"
                size="sm"
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col md={3}>
              <PsLabel text="Status" required />
            </Col>
            <Col md={9}>
              <Form.Control
                as="select"
                name="active_status"
                placeholder="Enter Address 1"
                size="sm"
                className="fw-bold form-select form-select-sm"
                required
              >
                <option value="1">Active</option>
                <option value="0">In-Active</option>
              </Form.Control>
            </Col>
          </Row>

          {/* Submit Button */}
          <Row className="mt-4">
            <Col>
              <Button
                type="submit"
                variant="contained"
                startIcon={<CheckIcon />}
              >
                Save
              </Button>
            </Col>
          </Row>
        </Form>
      </Spin>
    </>
  );
};
const AddAgencyForm = (props) => {
  return (
    <>
      <PsModalWindow size="lg" title="Add Partner" {...props}>
        {props.show && <AddAgencyFormComponent {...props} />}
      </PsModalWindow>
    </>
  );
};
export default AddAgencyForm;
